//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    props: ['vehicles', 'query', 'page'],
}
